/**
 * @desc 保存费用映射信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.CostItemMappingRequestRpcDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/saveCostItemMappingInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
